import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { S as SheetClose, a as StyledCloseButton } from './Sheet.styles-CshxnPna.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { I as Icon } from '../Icon/Icon-Cgh13Jz2.js';
import { h as close } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const CloseButtonSection = ({
  onClose,
  closeRef,
  closeButtonProps,
  closeButton,
  side = 'bottom'
}) => {
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId: closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.taktId,
    fallbackId: createStormTaktId('close-button')
  });
  return /*#__PURE__*/React__default.createElement(SheetClose, null, /*#__PURE__*/React__default.createElement(StyledCloseButton, _extends({}, getDataTaktAttributes({
    taktValue: closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.taktValue
  }), closeButtonProps, {
    tabIndex: 0,
    onClick: onClose,
    "aria-label": closeButton.label,
    buttonRef: closeRef,
    $side: side
  }), closeButton.type === 'icon' ? /*#__PURE__*/React__default.createElement(Icon, {
    type: close
  }) : closeButton.label));
};

export { CloseButtonSection as C };
//# sourceMappingURL=CloseButtonSection-DiIcP6t1.js.map
